module.exports = __webpack_public_path__ + "resources/img/sp_pricing_m.2a2818e6f5da70231f82a264f8c3f35a.png";